
import { useContext, Suspense, useEffect } from "react";
import SideBar from './component/SideBar';
import { Outlet } from "react-router";
import Header from '../src/component/Header';
import Footer from "./component/Footer";
import PopUpAlert from "./component/PopUpAlert";
import { AuthContext } from '../src/pages/auth/AuthContext';
import Loader from '../src/component/Loader';
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { chatActions } from "./redux/reducer/chatReducer";
import * as StompJs from '@stomp/stompjs';
import SockJS from 'sockjs-client/dist/sockjs';
import { stompClientService } from "./util/stompClientService";
import store from "./redux/store/store";
import { NotificationAPI } from "./api/NotificationAPI";
import 'react-photo-view/dist/react-photo-view.css';


function App() {
  const warningMessage = useSelector((store) => store.root.warningMessage);
  const allChatMessage = useSelector((store) => store.chat.allChatMessage);
  const currentChat = useSelector((store) => store.chat.currentChat);
  const { isLoading, message } = useContext(AuthContext);
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const dispatch = useDispatch();
  const { openSlideBar } = useSelector((store) => store.root);
  const [cookies, setCookie] = useCookies(["access_token", "refresh_token"]);

  // const findAllDeliveredAndSentMessage = async () => {
  //   try {
  //     const response = await NotificationAPI.getTotalUnreadMessage(selectedClub.clubId,userInfo.userId);
  //     if (response.Data) {
  //       response?.Data?.forEach((message) => {
  //         dispatch(chatActions.setUnReadMessageOneByOne({ id: message.chatGroupId ? message.chatGroupId : message.senderId, content: message.content }))
  //         dispatch(chatActions.setUnSeenMessages(message));
  //       })
  //     }
  //     return response?.Data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const findTotalUnreadMsg = async () => {
    try {
      const response = await NotificationAPI.getTotalUnreadMessage(selectedClub.clubId, userInfo.userId);
      dispatch(chatActions.setTotalUnReadMessage(response.Data));
    } catch (error) {
      console.error(error);
    }
  }

  const sendAckForMessageIsDelivered = (msg) => {
    if (stompClientService.isConnected()) {
      try {
        stompClientService.getClient().publish({
          destination: '/app/ack/delivered',
          body: JSON.stringify({
            chatMessageId: msg?.chatMessageId,
            receiverId: userInfo.userId,
            senderId: message.senderId,
            messageStatus: 'DELIVERED',
            deliveredTime: Date.now(),
            clubId: selectedClub.clubId,
            chatGroupId: msg.chatGroupId,
          })
        })
      } catch (error) {
        console.error(error);

      }
    } else {
      console.error("Not connected to WebSocket!");
    }
  };
  const sendAckForMessageIsSeen = (messages) => {
    if (stompClientService.isConnected()) {
      try {
        stompClientService.getClient().publish({
          destination: '/app/ack/seen',
          body: JSON.stringify({
            chatMessageIds: [messages?.chatMessageId],
            receiverId: userInfo.userId,
            senderId: message.senderId,
            messageStatus: 'SEEN',
            seenTime: Date.now(),
            clubId: selectedClub.clubId,
            chatGroupId: messages.chatGroupId,
          })
        })
      } catch (error) {
        console.error(error);

      }
    } else {
      console.error("Not connected to WebSocket!");
    }
  };

  useEffect(() => {
    if (cookies && cookies.access_token && userInfo.userId) {
      const client = stompClientService.getClient();
      if (!client || !client.active) {
        stompClientService.connect(cookies.access_token, (message) => {
          if (message?.clubId === store.getState()?.user?.selectedClub?.clubId) {
            if (message?.chatId === store.getState().chat?.currentChat?.chatId ||
               (!message?.chatId && message.receiverId === store.getState().chat?.currentChat?.privateChatUserId)) {
              dispatch(chatActions.setChatMessageOneByOne(message));
              if (message.receiverId === userInfo.userId) {
                sendAckForMessageIsSeen(message);
              }
            } else {
              dispatch(chatActions.updateChatListWithUnreadData(message))
              if (message.receiverId === userInfo.userId) {
                sendAckForMessageIsDelivered(message);
              }
            }
          }
        },
          (groupMessage) => {
            if (groupMessage?.clubId === store.getState()?.user?.selectedClub?.clubId) {
              if (groupMessage?.chatId === store.getState().chat?.currentChat?.chatId) {
                dispatch(chatActions.setChatMessageOneByOne(groupMessage));
                if (groupMessage.receiverId === userInfo.userId) {
                  sendAckForMessageIsSeen(groupMessage);
                }
              } else {
                dispatch(chatActions.updateChatListWithUnreadData(groupMessage))
                if (groupMessage.receiverId === userInfo.userId) {
                  sendAckForMessageIsDelivered(groupMessage);
                }
              }
            }
          },
          //On delivered message
          (message) => {
              // console.log("on message deliver:",message);
            if (message?.clubId === store.getState()?.user?.selectedClub?.clubId) {
              if (message?.chatId === store.getState().chat?.currentChat?.chatId) {
                dispatch(chatActions.updateChatMessage(message));
              }
            }
          },
          (message) => {
           // console.log("on message seen:",message);
            
            if (message?.clubId === store.getState()?.user?.selectedClub?.clubId) {
              if (message?.chatId === store.getState().chat?.currentChat?.chatId) {
                dispatch(chatActions.updateChatMessage(message));
              }
            }
          },
          () => {
            // findAllDeliveredAndSentMessage().then((data) => {
            //  // console.log("call this .....");

            //   //console.log(data);

            //   const unSennMessages = data.filter(item => (item.receiverId === userInfo.userId));
            //   if (unSennMessages?.length !== 0) {
            //     unSennMessages?.forEach((message) => {
            //       sendAckForMessageIsDelivered(message);
            //     });
            //   }
            // });
          }
        )
      }
    }
    return () => {
      // console.log("app is cleaning up ....", stompClientService?.connected);
      stompClientService.disconnect();
    }
  }, [cookies.access_token, userInfo.userId])

  useEffect(() => {
    if (selectedClub.clubId && userInfo.userId) {
      findTotalUnreadMsg();
    }
  }, [selectedClub.clubId, userInfo.userId]);

  return (
    <>
      <PopUpAlert id={warningMessage?.id} type={warningMessage?.type} message={warningMessage?.content} />
      <div className="root-dashboard">
        <div className={openSlideBar
          ?
          ((cookies.access_token && userInfo?.userId) || (cookies.refresh_token && userInfo?.userId))
            ?
            "root-dashboard-sidebar-con active"
            :
            "root-dashboard-sidebar-con active not-login"
          :
          ((cookies.access_token && userInfo?.userId) || (cookies.refresh_token && userInfo?.userId))
            ?
            "root-dashboard-sidebar-con"
            :
            "root-dashboard-sidebar-con not-login"
        }>
          <SideBar />
        </div>
        <div className="root-header-content">
          {((cookies.access_token && userInfo?.userId) || (cookies.refresh_token && userInfo?.userId)) && <Header />}
          <div className="root-main-content">
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
            {isLoading && <Loader />}
          </div>

          <Footer />
        </div>
      </div>
      <PopUpAlert type={message.type} message={message.content} />
    </>
  )
}

export default App
